export const DATE_FORMATS = {
  messages: 'MMM D',
  badge: 'MM/DD/YYYY',
};
